module.exports = __webpack_public_path__ + "img/client_8.cabe3a7e.png";